<template>
  <article class="persona-mini card" @click="$emit('click', $event)">
    <div class="persona-mini-icon" v-html="icon"></div>
    <h3>{{ title }}</h3>
    <p>{{ tagline }}</p>
  </article>
</template>

<script>
export default {
  name: 'PersonaMiniCard',
  props: {
    icon: { type: String, default: '' },
    title: { type: String, default: '' },
    tagline: { type: String, default: '' }
  }
};
</script>

<style lang="less" scoped>
.persona-mini {
  padding: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  min-height: 180px;
  position: relative;
  overflow: hidden;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.35s, box-shadow 0.35s;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #83e6ff, transparent);
    transform: translateX(-100%);
    transition: transform 0.7s ease;
    z-index: 2;
  }

  &:hover::before {
    transform: translateX(0);
  }
  &:hover h3 {
    color: #83e6ff;
  }
  &:hover p {
    color: #aab5cb;
  }
  &:hover {
    transform: translateY(-6px) !important;
    border-color: rgba(131, 230, 255, 0.45);
    box-shadow: 0 18px 38px rgba(0, 0, 0, 0.32), 0 0 0 1px rgba(131, 230, 255, 0.18);

    .persona-mini-icon {
      transform: scale(1.08) rotate(-4deg);
      box-shadow: 0 8px 22px rgba(131, 230, 255, 0.32);
    }
  }
}

.persona-mini-icon {
  width: 54px;
  height: 54px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(66, 217, 255, 0.18), rgba(66, 217, 255, 0.04));
  border: 1px solid rgba(66, 217, 255, 0.32);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #83e6ff;
  margin-bottom: 6px;
  transition: all 0.3s ease;

  ::v-deep svg {
    width: 26px;
    height: 26px;
  }
}

.persona-mini h3 {
  font-size: 18px;
  font-weight: 700;
  margin-top: 7px;
}

.persona-mini p {
  color: var(--muted);
  font-size: 13px;
  margin-top: 10px;
}

.persona-mini.reveal.show:nth-child(1) { transition-delay: 0.05s; }
.persona-mini.reveal.show:nth-child(2) { transition-delay: 0.12s; }
.persona-mini.reveal.show:nth-child(3) { transition-delay: 0.19s; }
.persona-mini.reveal.show:nth-child(4) { transition-delay: 0.26s; }
.persona-mini.reveal.show:nth-child(5) { transition-delay: 0.33s; }
.persona-mini.reveal.show:nth-child(6) { transition-delay: 0.4s; }
.persona-mini.reveal.show:nth-child(7) { transition-delay: 0.47s; }
.persona-mini.reveal.show:nth-child(8) { transition-delay: 0.54s; }
</style>
